module.exports = __webpack_public_path__ + "static/media/lamina28act2_2.dc79c84b.png";